import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const AddRoleContainer = styled(Box).attrs({
  px: '11px',
  horizontal: true,
  justify: 'space-between',
  align: 'center',
})`
  border-top: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
  border-bottom: ${p => `1px solid ${p.theme.colors.heavyLineOutline}`};
`;

export const RolesAvatarContainer = styled(Box).attrs({
  horizontal: true,
  flow: 10,
})``;
